<template>
    <div class="p-4 w-full">
        <slot />
    </div>
</template>
